// extracted by mini-css-extract-plugin
module.exports = {"BlogPage__Posts":"BlogPage__Posts","BlogPost":"BlogPost"};